<template>
  <div class="home">
    <AccountSetLayout
      layoutType="AccountSet"
      :layoutTitile="$t('changeTitle')"
    >
      <Tips
        title="注意事项"
        :tips="$t('tips')"
        class="withdrawal-tips margin-bottom-20"
      />
      <BasiceLayout :title="$t('changeTitle')">
        <div class="change-content">
<!--          <div class='change-item auto-with-item'>
            <el-row>
              <el-col
                :span="10"
                class="change-item-key"
              >
                <span class="left-key">{{$t('ZFBAccount')}}</span>
              </el-col>
              <el-col
                :span="14"
                class="change-item-value"
              >
                <div v-if="ZFBAccount && type == 'init' " class="right-key">{{ZFBAccount}}</div>
                <input
                  v-else
                  class="valu"
                  v-model="ZFBAccount"
                >
              </el-col>
            </el-row>
          </div>
          <div class='change-item auto-with-item'>
            <el-row>
              <el-col
                :span="10"
                class="change-item-key"
              >
                <span class="left-key">{{$t('ZFBName')}}</span>
              </el-col>
              <el-col
                :span="14"
                class="change-item-value"
              >
                <div v-if="ZFBName  && type == 'init' " class="right-key">{{ZFBName}}</div>
                <input
                  v-else
                  class="valu"
                  v-model="ZFBName"
                >
              </el-col>
            </el-row>
          </div> -->
          <div class="change-item display-flex-center auto-with-item">
            <el-col
                :span="10"
                class="change-item-key"
              >
              <span class=" left-key">提现金额</span>
              </el-col>
              <el-col
                :span="14"
                class="change-item-value"
              >
                <el-select v-model="autoWithCount" class="" >
                  <el-option default v-for="item in autoWithList" :key="item" :label="item" :value="item">
                </el-option>
                </el-select>
            </el-col>
          </div>
          <!-- 手机验证码 -->
           <div class="change-item display-flex-center auto-with-item">
            <el-col
                :span="10"
                class="change-item-key"
              >
              <span class=" left-key">验证码</span>
              </el-col>
              <el-col
                :span="14"
                class="change-item-value"
              >
                <SendVerifyCode
                  :iconType="noIcon"
                  type="text"
                  icon-type="emailCode"
                  v-model="verifyCode"
                  @verifyCodeTip="verifyCodeTip"
                  placeValue="发送手机验证码"
                />
            </el-col>
          </div>
          <div class='change-item display-flex-center auto-with-item'>
            <span class="key margin-right-20 ">{{$t('autoWithdrawal')}}</span>
            <el-switch
              v-model="autoWithdrawal"
              active-color="#13ce66"
              inactive-color="#ff4949"
            >
            </el-switch>
          </div>
          <div class='change-item display-flex-center auto-with-item'>
            <div
              v-if="ZFBAccount && type == 'init'"
              class="button"
              @click="changeType"
            >修改</div>
            <div
              v-else
              class="button"
              @click="open"
            >确定</div>
          </div>
        </div>
      </BasiceLayout>
      <AutoWithList></AutoWithList>
    </AccountSetLayout>
  </div>
</template>

<i18n>
{
  "en": {
    "changeTitle": "Auto Withdrawal",
    "ZFBAccount": "Old Password",
    "ZFBName": "New Password",
    "changeButton": "change",
    "autoWithdrawal": "auto Withdrawal",
     "tips": [
      "1.自动提现需完成高级实名验证，验证前往：账号设置-身份验证-<router-link>高级实名验证<===>/contact<router-link>",
      "2.请确认支付宝账号及姓名无误（必须同实名验证本人），且支付宝对应账号设置为可以被搜索到的模式。",
      "3.每月自动提现的次数为4次，如果估计每月收益为1600元，则提现金额选择400元即可。",
      "4.由于税务限制，单人单月可提现总额为 30000 元（与普通提现共享额度）。",
      "5.自动提现目前需要收取 5% 的税点，实际到账金额为扣除税点后的部分。"
    ]
  },
  "zn": {
    "changeTitle": "自动提现",
    "ZFBAccount": "支付宝账号",
    "ZFBName": "支付宝姓名",
    "changeButton": "确定",
    "autoWithdrawal": "自动提现"
  }
}
</i18n>


<script>
// @ is an alias to /src
import Header from "@/components/Header.vue";
import { mapState, mapActions, mapMutations } from "vuex";
import AccountSetLayout from "@/components/AccountSet/AccountSetLayout.vue";
import BasiceLayout from "@/components/Common/BasicLayout.vue";
import { Message } from "element-ui";
import Tips from "@/components/Common/Tips.vue";
import SendVerifyCode from "@/components/Common/SendCodeNoTel.vue";
import AutoWithList from "@/components/AccountSet/AutoWithList.vue";

export default {
  name: "home",
  components: {
    Header,
    BasiceLayout,
    AccountSetLayout,
    Tips,
    AutoWithList,
    SendVerifyCode,
  },
  data() {
    return {
      ZFBName: "",
      ZFBAccount: "",
      autoWithdrawal: false,
      type: '',
      autoWithCount: '',//提现金额
      verifyCode: '', //验证码
      noIcon: false,
      autoWithList: [
        200,
        300,
        400,
        500,
        1000,
        2000,
        5000
      ],
      verifyCode: ''
    };
  },
  created() {
    this.getInfo();
  },
  methods: {
    ...mapActions(["changeZFBInfo", "getZFBInfo","getCollection"]),
    // 手机验证
    verifyCodeTip(error) {
      if (error && error.message) {
        Message({
          message: error.message,
          type: "error",
        });
      }
    },
    open() {
      let { ZFBName, ZFBAccount, autoWithdrawal, autoWithCount, verifyCode } = this;
	  //判断是否填写收款信息
	  this.getCollection().then((res)=>{
	  	if(!res.data.bankAccount ||!res.data.bankAddress ||!res.data.ZFBAccount || !res.data.user_name){
	  		Message({
	  			message:"请先填写收款信息",
	  			type:"error",
	  		})
	  		this.$router.push({path:'/MyWallet'});
	  	}else{
      // if (autoWithdrawal && (!ZFBName || !ZFBAccount || !autoWithCount || !verifyCode)) {
      //   return Message({
      //     type: "error",
      //     message: "还没有填写支付宝账号和姓名",
      //   });
      // }
      this.changeZFBInfo({
        ZFBName: ZFBName,
        ZFBAccount: ZFBAccount,
        autoWithdrawal: autoWithdrawal ? 1 : 0,
        autoWithCount,
        verifyCode
      }).then((res) => {
        if (res.code === 200) {
          Message({
            type: "success",
            message: res.message || "修改成功",
          });
          this.getInfo();
        } else {
          Message({
            type: "error",
            message: res.message || "网络错误",
          });
        }
      });
	  }
	  })
    },
    changeType() {
		this.type = 'change';
		// this.open();
    },
    getInfo() {
      this.getZFBInfo().then((res) => {
        // res = [{"ZFBAccount":"13650566819","ZFBName":"陈瑶","autoWithdrawal":1,"autoWithCount":200}];
		// console.log(this);
		// console.log(res[0].ZFBName);
        if (res && res[0] && res[0].ZFBAccount) {
          this.type = 'init';
          this.ZFBName = res[0].ZFBName;
          this.ZFBAccount = res[0].ZFBAccount;
          this.autoWithdrawal = !!res[0].autoWithdrawal;
          this.autoWithCount = res[0].autoWithCount;
        }
      });
    },
  },
};
</script>

<style  lang="stylus">
.change-item {
  margin-top: 20px;
}

.change-content input {
  width: 200px;
  height: 28px;
  -webkit-appearance: none;
  background-color: #fff;
  background-image: none;
  border: 1px solid #dcdfe6;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  color: #c7cacc;
  display: inline-block;
  font-size: inherit;
  height: 30px;
  line-height: 30px;
  outline: none;
  padding: 0 10px;
  -webkit-transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
  transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
  font-size: 10px;
  height: 40px;
}

.change-content .key {
  font-size: 16px;
  color: #96999b;
  text-align: right;
  line-height: 42px;
}

.change-item-value {
  text-align: left;
}

.change-item-key {
  text-align: right;
  padding-right: 20px;
}

.change-content {
  margin-top: 80px;
  min-height: 500px;
}

.last-wrap {
  postion: relative;
}

.last-button-wrap {
  margin-top: 40px;
  display: flex;
}

.change-content .forget {
  font-size: 14px;
  color: #13B8BC;
  text-align: right;
  line-height: 35px;
  margin-left: 30px;
}

.change-content .change {
  background-image: linear-gradient(-180deg, #15BCAD 2%, #10B2CB 100%);
  font-family: PingFangSC-Regular;
  font-size: 14px;
  color: #FFFFFF;
  text-align: center;
  line-height: 35px;
  width: 90px;
  height: 35px;
}

.home {
  height: 100% !important;
}

.left-key{
  width: 100%;
  color: #96999b;
  text-align: right;
  height: 50px;
  font-size: 14px;
  line-height: 50px;
  margin: 10px 0;
}
.right-key{
  height: 50px;
  line-height: 50px;
  font-size: 24px;
}

.auto-with-item{
  width: 50%;
  margin: 20px auto;
}
</style>

